import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const NameKeyForEdi = (props: InputComponentProps) => {
  const requirements = 'Example: GRDA';
  const validate = ({ value }) => {
    const regex = /^[A-Z]{4}$/;
    if (value.trim().length < 1) return 'Please enter the Name key';
    if (!regex.test(value.trim())) return 'Please enter a valid Name key (4 uppercase letters)';

    return true;
  };

  return (
    <ValidatingInput
      autoComplete="name-key"
      label="Name key"
      name="nameKeyForEdi"
      placeholder="Name key (4 uppercase letters)"
      validate={validate}
      requirements={requirements}
      {...props}
      helpContent={{
        type: 'ENROLLMENT_FIELDS',
      }}
    />
  );
};
